import {computed, Injectable, signal} from '@angular/core';
import {UploadProgress} from "../types/upload-progress.types";

@Injectable({
  providedIn: 'root'
})
export class UploadProgressService {
  private _uploadState = signal<UploadProgress>({
    progress: 0,
    completed: false
  });
  public uploadProgressState = this._uploadState.asReadonly();
  public currentProgress = computed(() => this._uploadState().progress);
  public isCompleted = computed(() => this._uploadState().completed);

  public updateProgress(uploadProgress: UploadProgress): void {
    this._uploadState.set(uploadProgress);
  }

  public getUpdateProgressByFileName(fileName: string): boolean {
    return this.uploadProgressState().fileName === fileName;
  }

  public resetProgress(): void {
    this._uploadState.set({
      progress: 0,
      completed: false
    });
  }
}
